import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'antd';
import Icon from 'component/Icon';
import styles from './index.module.scss';
import { Person } from 'type/contact';
import { RootState } from 'model';
import MemberWrapper from './wrapper';
import { IMember } from 'type/meetingDetail';
import meeting from '../../model/meeting/index';
interface IProps {
  disabledList?: IMember[];
  show: boolean;
  close: () => void;
  onSubmit: (selectPerson: Person[]) => void;
  loadLabel?: boolean;
  title?: string;
  beEmbedded?: boolean;
}

const AddMeetingMember: React.FunctionComponent<IProps> = ({ disabledList, show, close, onSubmit, title = '添加参会人', beEmbedded = false }) => {
  const [selectPerson, setSelectPerson] = useState<any[]>([]);

  const handleClose = () => {
    close();
    setSelectPerson([]);
  };

  const handleOk = () => {
    if (selectPerson.length > 0) onSubmit(selectPerson);
    handleClose();
  };

  const checkedClick = (selected: any) => {
    setSelectPerson(selected.detail[0]);
  };

  const modalWidth = beEmbedded ? 640 : 800;

  return (
    <Modal
      title={title}
      visible={show}
      onCancel={handleClose}
      width={modalWidth}
      closeIcon={<Icon type="iconlist_close_ic1x" size={24} />}
      className={styles.modal}
      centered
      destroyOnClose
      footer={[
        <Button key="showMore" onClick={handleClose}>
          取消
        </Button>,
        <Button key="submit" type="primary" onClick={handleOk} htmlType="submit" disabled={!selectPerson.length}>
          确定
        </Button>
      ]}
    >
      <div className={styles.main}>
        <MemberWrapper width={modalWidth - 40} onChange={checkedClick} disabledList={disabledList} />
      </div>
    </Modal>
  );
};

export default AddMeetingMember;
